import { NavigableModal } from '$components'
import { useNavigate, useParams } from 'react-router-dom'
import { EditTeamMemberProfileForm, EditTeamMemberProfileSchema, Input } from '$features/team/forms/edit-team-member-profile/index'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { userShowOptions, userShowQueryKey, userUpdateMutation } from '$api-client/@tanstack/react-query.gen'
import { ToastHelper } from '$components'

export function EditTeamMemberProfileModal() {
  const navigate = useNavigate()
  const { id } = useParams()
  const queryClient = useQueryClient()

  const { data } = useQuery({
    ...userShowOptions({
      path: {
        id: Number(id),
      },
      query: {
        include_deleted: true,
      },
    }),
  })

  const { mutate: updateTeamMember, isPending: isUpdatingTeamMember } = useMutation({
    ...userUpdateMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: userShowQueryKey({
          path: {
            id: Number(id),
          },
        }),
      })
      ToastHelper.success('Team member profile updated successfully.')
      handleClose()
    },
    onError: () => ToastHelper.error('Failed to update team member profile.'),
  })

  const handleClose = () => navigate(-1)

  const handleSubmit = async (values: EditTeamMemberProfileSchema) => {
    updateTeamMember({
      path: {
        id: Number(id),
      },
      body: {
        first_name: values[Input.FirstName],
        last_name: values[Input.LastName],
      },
    })
  }

  const teamMember = data?.data

  if (!teamMember) {
    return null
  }

  return (
    <EditTeamMemberProfileForm
      onSubmit={handleSubmit}
      onCancel={handleClose}
      isLoading={isUpdatingTeamMember}
      defaultValues={{
        [Input.FirstName]: teamMember.first_name,
        [Input.LastName]: teamMember.last_name,
      }}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>
            Edit Team Member Profile
          </NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <EditTeamMemberProfileForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <EditTeamMemberProfileForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </EditTeamMemberProfileForm>
  )
}
